export const FEATURE_NAMESPACE = 'feature.sales-forecast'
